/* global __DEV__ */

import defaultConfig from './default';
import production from './production';
import development from './development';

const environmentConfig = __DEV__ ? development : production;

const auth = {
  ...defaultConfig.auth,
  ...environmentConfig.auth,
};

export default {
  ...defaultConfig,
  ...environmentConfig,
  auth,
};
